  <!-- Summary -->
  <div class="d-flex flex-column mb-3 panel-main-title" data-testid="discovery-title-box">
    <label>Top Tax Strategies Identified</label>
  </div>

  <div class="text-muted mb-3 d-flex align-items-center gap-3 rap-questionnarie-strategies-detail" data-testid="discovery-jaine-intro">
    <img src="/images/jaine-bot.png" alt="AI Avatar" class="summary_icon" />
    <div>
      <p class="text-dark mb-2">
        jAIne here! I found {{
        aiSuggestedStrategies?.length || 0 }} suggested tax strategies based on the 1040 you uploaded.
        If you’d like, I can ask some questions to look for additional opportunities that don’t always show up on the tax
        return.</p>
        <p class="text-dark mb-0"> Here’s a preview of the
          <ng-container *ngIf="(aiSuggestedStrategies?.length || 0) >= 5; else lessThanFive">
            <strong class="text-dark">Top 5</strong>
          </ng-container>
          <ng-template #lessThanFive>
            <strong class="text-dark">Top {{ aiSuggestedStrategies?.length || 0 }}</strong>
          </ng-template>
          strategies, representing the highest estimated tax savings I can see from the return alone.
        </p>
    </div>
  </div>

<div class="chat-container">
  <div class="top-five-summary" data-testid="discovery-chat-top5" *ngIf="aiSuggestedStrategies?.length">
    <!-- Strategy List -->
    <div class="strategy-list">
      <!-- Header Row -->
      <div class="strategy-list-header d-flex justify-content-between align-items-center px-3 py-2">
        <span class="fw-bold">Tax Strategy</span>
        <span class="fw-bold">Est. Tax Savings</span>
      </div>
      <div *ngFor="let item of aiSuggestedStrategies | slice:0:5; let i = index" class="strategy-info-box top-five-row">
        <span class="strategy-index">{{ i + 1 }}</span>
        <span class="strategy-name top-five-name" [title]="item.name">{{ item.name }}</span>
        <span class="top-five-savings">{{ item.totalSavings }}</span>
      </div>
    </div>
    <button type="button" class="find-more-btn" data-testid="discovery-find-more"
      [disabled]="quickActionsDisabled" (click)="findMoreStrategies()">Find More Strategies</button>
  </div>
  <div class="messages" #messagesContainer>
    <div *ngFor="let msg of messages; let i = index" [ngClass]="msg.sender" class="message-row"
      [class.reply-slot]="msg.sender === 'ai' && (msg.text !== '' || msg.pending) && i === messages.length - 1">
      <ng-container *ngIf="msg.sender === 'ai' && (msg.text !== '' || msg.pending)">
        <img src="/images/jaine-bot.png" alt="AI Avatar" class="ai_icon" />
        <div class="bubble" [class.bubble-error]="msg.error">
          <span *ngIf="msg.pending && msg.text === ''" class="summarizing" data-testid="discovery-chat-summarizing">Summarizing<span class="dots"><span>.</span><span>.</span><span>.</span></span></span>
          <markdown *ngIf="msg.text !== ''" [data]="msg.text"></markdown>
          <div *ngIf="msg.messageId" class="rating-actions">
            <button class="rating-btn" (click)="onCopyMessage(i)">
              <mat-icon>content_copy</mat-icon>
              {{ copiedIndex === i ? 'Copied' : 'Copy' }}
            </button>

            <button class="rating-btn" [class.liked]="msg.userRating === 1" (click)="rateMessage(i, 1)">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
                <path d="M14 9V5a3 3 0 0 0-3-3l-4 9v11h11.28a2 2 0 0 0 2-1.7l1.38-9a2 2 0 0 0-2-2.3H14z"/>
                <path d="M7 22H4a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h3" fill="none" stroke="currentColor" stroke-width="2"/>
              </svg>
              {{ msg.userRating === 1 ? 'Liked' : 'Like' }}
            </button>

            <button class="rating-btn" [class.disliked]="msg.userRating === -1" (click)="rateMessage(i, -1)">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
                <path d="M10 15v4a3 3 0 0 0 3 3l4-9V2H5.72a2 2 0 0 0-2 1.7l-1.38 9a2 2 0 0 0 2 2.3H10z"/>
                <path d="M17 2h2.67A2.31 2.31 0 0 1 22 4v7a2.31 2.31 0 0 1-2.33 2H17" fill="none" stroke="currentColor" stroke-width="2"/>
              </svg>
              {{ msg.userRating === -1 ? 'Disliked' : 'Dislike' }}
            </button>
          </div>

          <div *ngIf="feedbackIndex === i" class="feedback-panel">
            <div class="feedback-header">
              <span>Why is this a bad response?</span>
              <button class="feedback-close" (click)="closeFeedback()">&#x2715;</button>
            </div>
            <div class="feedback-body feedback-input-area">
              <input type="text" class="feedback-input" placeholder="Provide Feedback" [(ngModel)]="feedbackText" (keyup.enter)="submitFeedback(i)" />
              <button class="feedback-submit" (click)="submitFeedback(i)">Submit</button>
            </div>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="msg.sender === 'user'">
        <div class="bubble">{{ msg.text }}</div>
        <div class="user-icon">{{ getUserInitials() }}</div>
      </ng-container>
    </div>
    <!-- SHOW LOADING GIF BEFORE STREAM STARTS -->
    <div *ngIf="isLoading" class="message-row ai reply-slot">
      <img class="loading-img" src="/images/loading.gif" alt="loading..." />
    </div>
  </div>

  <div class="input-area align-items-start">
    <mat-form-field class="message-box" appearance="outline">
      <textarea #chatInput matInput placeholder="Type your message..." data-testid="discovery-chat-input" [(ngModel)]="userInput"
        (keyup.enter)="sendPrompt()" [disabled]="isStreaming" rows="1"></textarea>
    </mat-form-field>

    <button mat-icon-button color="primary" (click)="sendPrompt()" [disabled]="isStreaming || !userInput.trim()"
      data-testid="discovery-chat-send" class="send-btn">
      <mat-icon>arrow_forward</mat-icon>
    </button>
  </div>
  <div class="mt-0 d-flex justify-content-center align-items-center gap-3 flex-wrap">
  <button class="button btn-sm small" data-testid="discovery-chat-restart" (click)="restartQuestionnaire()">
    Restart Discovery
  </button>
</div>
</div>
<div class="text-muted small">
    <p class="mb-0 d-flex gap-2 align-items-center">jAIne is AI and can make mistakes. Please double-check responses.</p>
    <p class="mb-0 d-flex gap-2 align-items-center">All questions are optional. Click the Next button to see additional tax strategy suggestions based on your answers.</p>
</div>
